var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Input as AntInput } from "antd";
import "./Input.scss";
var Input = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx(AntInput, __assign({}, props, { className: "input ".concat(className || ""), ref: ref })));
});
Input.TextArea = function (_a) {
    var props = __rest(_a, []);
    return _jsx(AntInput.TextArea, __assign({}, props));
};
Input.Password = function (_a) {
    var props = __rest(_a, []);
    return _jsx(AntInput.Password, __assign({}, props));
};
Input.Group = AntInput.Group;
Input.Search = AntInput.Search;
export default Input;
